const PriceNoteIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
            <path fill="currentColor" fillRule="evenodd" d="M5 14h8v6.05a2.5 2.5 0 1 0 1 0V14h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1zM22 4H5v9h17V4zm-8.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        </svg>
    )
}
export default PriceNoteIcon